// Utility to convert route patterns to regex
export function routeToRegex(route: string): RegExp {
  const pattern = route
    .replace(/\/\[\[.*?]]/g, "(.+?)?") // [[param]] is an optional [param]
    .replace(/\[.*?]/g, "[^/]+") // [param] matches any characters except '/'
    .replace(/\*\*/g, "((?:[^/]+/)*[^/]*)"); // ** matches any path segments
  return new RegExp(`^${pattern}/?$`); // Allows optional trailing slash
}
